import { NavLink, Outlet } from 'react-router-dom';
import {
  ArrowDownUp,
  ArrowLeftRight,
  Banknote,
  Calendar,
  CalendarCheck,
  FileText,
  GitCompare,
  Repeat,
  TrendingUp,
} from 'lucide-react';
import { cn } from '@/lib/utils';
// Sprint 6.9.10 — CaisseDashboardCard retiré (doublon avec CaisseDashboardSimple Sprint 6.9.8
// + widget Trésorerie prévisionnelle Sprint 6.9.9 sur le tableau de bord). Les KPIs
// "Solde groupe maintenant / Projeté 30j/90j / Net 30j par activité / Top risques cash-flow"
// sont désormais répartis entre /finances/caisse/operations (Solde réel) et / (Trésorerie prév).

const ITEMS = [
  { to: '/finances/caisse/operations', label: 'Opérations', icon: ArrowDownUp },
  { to: '/finances/caisse/tresorerie', label: 'Trésorerie', icon: TrendingUp },
  { to: '/finances/caisse/justificatifs', label: 'Justificatifs', icon: FileText },
  { to: '/finances/caisse/cloture', label: 'Clôture', icon: CalendarCheck },
  { to: '/finances/caisse/rapprochement', label: 'Rapprochement', icon: GitCompare },
  { to: '/finances/caisse/comptes', label: 'Comptes', icon: Banknote },
  { to: '/finances/caisse/echeanciers', label: 'Échéanciers', icon: Calendar },
  { to: '/finances/caisse/avances', label: 'Avances inter-activités', icon: ArrowLeftRight },
  { to: '/finances/caisse/charges-recurrentes', label: 'Charges récurrentes', icon: Repeat },
];

export function FinancesCaisseLayout(): JSX.Element {
  return (
    <div className="flex h-full flex-col">
      <div className="sticky top-0 z-10 border-b border-slate-200 bg-white/80 backdrop-blur">
        <div className="scrollbar-thin flex items-end gap-1 overflow-x-auto px-4">
          {ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) =>
                cn(
                  'flex shrink-0 items-center gap-2 whitespace-nowrap border-b-2 px-3 py-3 text-sm font-semibold transition-colors',
                  isActive
                    ? 'border-orange-600 text-orange-700'
                    : 'border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-800',
                )
              }
            >
              <item.icon className="h-4 w-4" />
              {item.label}
            </NavLink>
          ))}
        </div>
      </div>
      <div className="scrollbar-thin flex-1 overflow-y-auto bg-slate-50/40">
        <Outlet />
      </div>
    </div>
  );
}
